import type { RegisterOptions } from "react-hook-form";
import { Controller, useFormContext } from "react-hook-form";
import { TranscriptFileTypeSelectComponent } from "./TranscriptFileTypeSelectComponent";

interface TranscriptFileTypeSelectProps {
  aiFileDownloadUrl?: string;
  name: string;
  rules: RegisterOptions;
  supportsAi: boolean;
}

export const TranscriptFileTypeSelect = ({
  name,
  rules,
  supportsAi,
  aiFileDownloadUrl,
  ...passThroughProps
}: TranscriptFileTypeSelectProps) => {
  const { control } = useFormContext();

  return (
    <Controller<Record<string, string>>
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, value } }) => (
        <TranscriptFileTypeSelectComponent
          onChange={onChange}
          value={value}
          supportsAi={supportsAi}
          aiFileDownloadUrl={aiFileDownloadUrl}
          {...passThroughProps}
        />
      )}
    />
  );
};
